import { render, staticRenderFns } from "./CloudServer.vue?vue&type=template&id=de8efa18&scoped=true"
import script from "./CloudServer.vue?vue&type=script&lang=js"
export * from "./CloudServer.vue?vue&type=script&lang=js"
import style0 from "./CloudServer.vue?vue&type=style&index=0&id=de8efa18&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8efa18",
  null
  
)

export default component.exports